import styles from './PersonalDataDelivery.module.css'
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setOrderData} from "../../Reducer/GlobalReducer";
import React, {useEffect, useRef, useState} from "react";
import useLongTask, {LongTaskItemCbInt} from "../../Util/LongTaskItem/UseLongTask";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import useFormValidator, {FormValidatorInt} from "../../FormValidator/FormValidator";
import WaitLoader from "../../WaitLoader/WaitLoader";

interface PersonalDataInt
{
    orderId:string
    sessionId:string
    family:string;
    name:string;
    middleName?:string;

}

interface NextButtonCallBackInt
{
    ():void
}
interface PersonalDataPropsInt
{
    cbExecute: NextButtonCallBackInt
}

export default function RuPersonalDataDelivery({cbExecute}:PersonalDataPropsInt){
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })

    const mainCont = useRef<HTMLDivElement>(null)

    const dispatch = useDispatch()
    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })
    const errorLineRef = useRef<ErrorLineItemRef>(null)


    const [stage, setStage] = useState(0)

    const [checkRs, setCheckRs] = useState("")


    const pdData = useRef<PersonalDataInt>()
    const [ldrPdData,rsPdData,exPdData] = useApiQuery("/sell/sim/document/add","post",pdData);



    const [lockForm, setLockForm] = useState(false)
    const [acceptPd, setAcceptPd]= useState(false)


    const normFio = (val: string)=>{
        return String(val).charAt(0).toUpperCase() + String(val).slice(1).toLowerCase();
    }


    const [formData,setFormData]=useState<FormValidatorInt[]>([
        {
            val:"",
            id:"family",
            errText: "Не корректная фамилия",
            regExp: /^[ёа-я]+[ёа-я-\s]+$/ui,
            isCheck: true,
            valid: true,
            normalize: normFio,
        },
        {
            val:"",
            id:"name",
            errText: "Не корректное имя",
            regExp: /^[ёа-я]+[ёа-я-\s]+$/ui,
            isCheck: true,
            valid: true,
            normalize: normFio,

        },
        {
            val:"",
            id:"middleName",
            errText: "Не корректное отчество",
            regExp: /(^[ёа-я]+[ёа-я-\s]+$)|(^$)/ui,
            isCheck: true,
            valid: true,
            normalize: normFio,

        },



    ])
    const [validate,validateById,getValue,setValue,getErrText] = useFormValidator(formData)



    useEffect(()=>{
        if(mainCont.current)mainCont.current.scrollIntoView()
    },[stage])


    const handleSend = () =>{
        if(!validate())return
        //if(errorLineRef.current)errorLineRef.current.show("",true,100)

        pdData.current = {
            orderId: orderData?.orderId ? orderData?.orderId : "-1",
            sessionId: orderData?.sessionId ? orderData?.sessionId : "-1",
            family: getValue("family")?.trim(),
            name: getValue("name")?.trim(),
            middleName: getValue("middleName")?.trim(),
        }
        console.log(pdData.current)
        exPdData().then((e)=>{
            if(e?.success && e?.payload)
            {
                dispatch(setOrderData({...orderData,personalData:{
                        isCorrect: true,
                        isPresent: true
                    }}))
                if(cbExecute)cbExecute()
                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)
        }).catch((e)=>{
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)
        })



    }

    const buildPdText = () =>{
        if(orderData?.regMode === 1)
        {
            return(
                <p className={styles.pdTitle}>
                    Вы выбрали режим саморегистрации ( регистрация через «Госуслуги» ). Что бы мы могли доставить Вам SIM карту, нам нужны Ваши ФИО для оператора доставки,
                    на эти данные будет осуществлена доставка.
                </p>
            )
        }
        return(
            <p className={styles.pdTitle}>
                Что бы мы могли доставить Вам SIM карту, нам нужны Ваши ФИО для оператора доставки,
                на эти данные будет осуществлена доставка.
            </p>
        )
    }

    return(
        <div className={styles.pdCont} ref={mainCont}>
            {buildPdText()}
            <div className={styles.pdPersData}>
                <p>Политика использования персональных данных<a href={baseUrl + '/static/ppd-politic.docx'} target={"_blank"}>скачать</a></p>
            </div>

            <p>Заполните форму</p>


            <div className={styles.formView}>
                <form >
                    <div className="row  ">
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Фамилия</label>
                            <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"Фамилия"}
                                   value={getValue("family")}
                                   onBlur={()=>validateById("family")}
                                   onChange={(e)=>setValue("family",e.target.value)}
                                   maxLength={30}
                                   readOnly={lockForm}
                            >
                            </input>
                            <div  className={["", styles.errMessage].join(' ')}>{getErrText("family")}</div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Имя</label>
                            <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"Имя"}
                                   value={getValue("name")}
                                   onBlur={()=>validateById("name")}
                                   onChange={(e)=>setValue("name",e.target.value)}
                                   maxLength={30}
                                   readOnly={lockForm}
                            >

                            </input>
                            <div  className={["", styles.errMessage].join(' ')}>{getErrText("name")}</div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label col-form-label-sm">Отчество</label>
                            <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"Отчество"}
                                   value={getValue("middleName")}
                                   onBlur={()=>validateById("middleName")}
                                   onChange={(e)=>setValue("middleName",e.target.value)}
                                   maxLength={40}
                                   readOnly={lockForm}
                            >

                            </input>
                            <div  className={["", styles.errMessage].join(' ')}>{getErrText("middleName")}</div>
                        </div>
                    </div>





                    <div className="form-check form-check-inline my-2">
                        <input className="form-check-input" type="checkbox" id="inlineCheckbox1"
                               checked={acceptPd}
                               onChange={()=>setAcceptPd(!acceptPd)}
                               style={{cursor:"pointer"}}
                        />
                        <label className="form-check-label" htmlFor="inlineCheckbox1" style={{cursor:"pointer"}}>Даю согласие на обработку данных</label>
                    </div>
                    <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>


                    <div className={"row my-2"}>
                        <div className="col-12">
                            <div className={styles.btnCont}>
                                <button type="button" className="btn btn-face"
                                        disabled={!acceptPd || stage===1 || stage ===2}
                                        onClick={()=>handleSend()}
                                >Отправить</button>
                                <WaitLoader loading={ldrPdData} api={rsPdData} onlyLoading={true} >
                                </WaitLoader>

                            </div>

                        </div>

                    </div>





                </form>
            </div>

        </div>
    )
}